/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateCustomRequest } from '../models/CreateCustomRequest';
import type { CreateCustomResponse } from '../models/CreateCustomResponse';
import type { TestCustomConnectionRequest } from '../models/TestCustomConnectionRequest';
import type { TestCustomConnectionResponse } from '../models/TestCustomConnectionResponse';
import type { UpdateCustomRequest } from '../models/UpdateCustomRequest';
import type { UpdateCustomResponse } from '../models/UpdateCustomResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CustomService {

    /**
     * Updates an existing custom integration.
     * @param requestBody The request.
     * @returns UpdateCustomResponse OK
     * @throws ApiError
     */
    public static updateCustom(
        requestBody?: UpdateCustomRequest,
    ): CancelablePromise<UpdateCustomResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/integrations/custom/updateCustom',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                404: `Not Found`,
            },
        });
    }

    /**
     * Creates a new custom integration.
     * @param requestBody
     * @returns CreateCustomResponse OK
     * @throws ApiError
     */
    public static createCustom(
        requestBody?: CreateCustomRequest,
    ): CancelablePromise<CreateCustomResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/custom/createCustom',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Tests the Custom connection.
     * @param requestBody
     * @returns TestCustomConnectionResponse OK
     * @throws ApiError
     */
    public static testCustomConnection(
        requestBody?: TestCustomConnectionRequest,
    ): CancelablePromise<TestCustomConnectionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/custom/testConnection',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
